module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('center', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.SAVING_USER_SPINNER))]) : _vm._e(), _vm._v(" "), _c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userLoadingError),
      expression: "userLoadingError"
    }],
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.labels.LOADING_USER_ERROR) + "\n    ")]), _vm._v(" "), (_vm.userLoaded) ? _c('div', [_c('div', {
    staticClass: "content col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "card card-indent"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row py-1"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('FirstName')
    }
  }, [_vm._v(_vm._s(_vm.labels.FIRSTNAME) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.FirstName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.FirstName),
      expression: "user.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.FirstName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('FirstName'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('LastName')
    }
  }, [_vm._v(_vm._s(_vm.labels.LASTNAME) + " *")]), _vm._v(" "), (!_vm.editMode) ? _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    attrs: {
      "href": "#",
      "title": "Profile Edit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toEditMode($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.LastName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.LastName),
      expression: "user.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.LastName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('LastName'))
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('FirstNameUnicode')
    }
  }, [_vm._v(_vm._s(_vm.labels.FIRSTNAME) + " (Unicode)")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.FirstNameUnicode))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.FirstNameUnicode),
      expression: "user.FirstNameUnicode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.FirstNameUnicode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.FirstNameUnicode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('FirstNameUnicode'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('LastNameUnicode')
    }
  }, [_vm._v(_vm._s(_vm.labels.LASTNAME) + " (Unicode)")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.LastNameUnicode))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.LastNameUnicode),
      expression: "user.LastNameUnicode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.LastNameUnicode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.LastNameUnicode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('LastNameUnicode'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Gender')
    }
  }, [_vm._v(_vm._s(_vm.labels.GENDER) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.Gender))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Gender),
      expression: "user.Gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("F")]), _vm._v(" "), _c('option', [_vm._v("M")])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Gender'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Email')
    }
  }, [_vm._v(_vm._s(_vm.labels.EMAIL) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isNew) ? _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.user.Email
    }
  }, [_vm._v(_vm._s(_vm.user.Email))]) : _vm._e(), _vm._v(" "), (_vm.isNew & _vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Email),
      expression: "user.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode & _vm.isNew) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Email'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.ACCOUNT_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.Domain) + "\\" + _vm._s(_vm.user.SAMAccountName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Language')
    }
  }, [_vm._v(_vm._s(_vm.labels.LANGUAGE) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.getCountryCode(_vm.user.Language)))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Language),
      expression: "user.Language"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      key: lang.code,
      domProps: {
        "value": lang.code
      }
    }, [_vm._v(_vm._s(lang.countryCode))])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Language'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.PRINCIPAL_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.PrincipalName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.OU))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.OU))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('DisplayName')
    }
  }, [_vm._v(_vm._s(_vm.labels.CLASS_DISPLAY_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.DisplayName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.DisplayName),
      expression: "user.DisplayName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.DisplayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.DisplayName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('DisplayName'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Phone')
    }
  }, [_vm._v(_vm._s(_vm.labels.PHONE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Phone))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Phone),
      expression: "user.Phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Phone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Phone'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Company')
    }
  }, [_vm._v(_vm._s(_vm.labels.COMPANY) + " "), (_vm.isNewSharePoint) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Company))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Company),
      expression: "user.Company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Company = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Company'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Country')
    }
  }, [_vm._v(_vm._s(_vm.labels.COUNTRY))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.country))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.CountryCode),
      expression: "user.CountryCode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.CountryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.countryCodes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.Value
      }
    }, [_vm._v("\n                          " + _vm._s(option.Text) + "\n                        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Country'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Website')
    }
  }, [_vm._v(_vm._s(_vm.labels.WEBSITE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Website))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Website),
      expression: "user.Website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Website = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Website'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Location')
    }
  }, [_vm._v(_vm._s(_vm.labels.LOCATION))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Location))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Location),
      expression: "user.Location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Location = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Location'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('State')
    }
  }, [_vm._v(_vm._s(_vm.labels.STATE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.State))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.State),
      expression: "user.State"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.State)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.State = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('State'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('PostalCode')
    }
  }, [_vm._v(_vm._s(_vm.labels.POSTAL_CODE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.PostalCode))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.PostalCode),
      expression: "user.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.PostalCode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('PostalCode'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Street')
    }
  }, [_vm._v(_vm._s(_vm.labels.STREET))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Street))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Street),
      expression: "user.Street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Street = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Street'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('PersonalTitle')
    }
  }, [_vm._v(_vm._s(_vm.labels.PERSONAL_TITLE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.PersonalTitle))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.PersonalTitle),
      expression: "user.PersonalTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.PersonalTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.PersonalTitle = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('PersonalTitle'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Department')
    }
  }, [_vm._v(_vm._s(_vm.labels.DEPARTMENT))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.Department))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Department),
      expression: "user.Department"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Department)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Department = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Department),
      expression: "user.Department"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaDepartments), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Department'))
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('CostCenter')
    }
  }, [_vm._v(_vm._s(_vm.labels.COST_CENTER))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.CostCenter))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.CostCenter),
      expression: "user.CostCenter"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.CostCenter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaCostCenters), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('CostCenter'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('JobTitle')
    }
  }, [_vm._v(_vm._s(_vm.labels.JOB_TITLE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.JobTitle))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.JobTitle),
      expression: "user.JobTitle"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.JobTitle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaJobTitles), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('JobTitle'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Description')
    }
  }, [_vm._v(_vm._s(_vm.labels.DESCRIPTION))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Description))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Description),
      expression: "user.Description"
    }],
    staticClass: "form-control stop-resize",
    domProps: {
      "value": (_vm.user.Description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Description = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Description'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.INFO))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.Info))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.USER_TYPE))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.ExtensionAttribute6))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.CANONICAL_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.user.CanonicalName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-gray-lightest border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('ProxyAddresses')
    }
  }, [_vm._v(_vm._s(_vm.labels.PROXY_ADDRESSES))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.user.ProxyAddresses), function(proxyAddress, index) {
    return _c('div', {
      staticClass: "group-record"
    }, [_vm._v("\n                        " + _vm._s(proxyAddress) + "\n\n                        "), (_vm.editMode && _vm.isProxyAddressEditable(proxyAddress) && !_vm.isSabaUser) ? _c('a', {
      staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeProxyAddress(proxyAddress, index)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-close"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProxyAddressPrefix),
      expression: "selectedProxyAddressPrefix"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "20%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProxyAddressPrefix = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.proxyAddressesPrefix), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })), _vm._v(" "), _c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyAddressValue),
      expression: "proxyAddressValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%",
      "display": "inline-block"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proxyAddressValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proxyAddressValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    staticStyle: {
      "color": "green",
      "top": "7px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addProxyAddress($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-plus"
  })])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('ProxyAddresses'))
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-gray-lightest",
    class: {
      'border-bottom': _vm.editMode && !_vm.isSabaUser
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Groups')
    }
  }, [_vm._v(_vm._s(_vm.labels.GROUPS))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.user.Groups), function(group, index) {
    return _c('div', {
      staticClass: "group-record"
    }, [_vm._v("\n                        " + _vm._s(group) + "\n\n                        "), (_vm.editMode && !_vm.isSabaUser && _vm.isGroupEditable(group)) ? _c('a', {
      staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeGroup(group, index)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-close"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), _c('div', [(_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroup),
      expression: "selectedGroup"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableGroups), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    staticStyle: {
      "color": "green",
      "top": "7px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroup($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-plus"
  })]) : _vm._e()]), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Groups'))
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), (_vm.editMode && _vm.summaryErrors && _vm.summaryErrors.length > 0) ? _c('div', {
    staticClass: "fields-row border-gray-lightest border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.summaryErrors), function(item) {
    return _c('div', {
      staticClass: "smaller alert-danger"
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
    staticClass: "pt-1 pb-1 border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancelEditMode
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('center', [_c('div', [_c('div', {
    staticClass: "photo-container",
    class: {
      'white-border': !_vm.editMode || _vm.isSabaUser
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "96px",
      "max-height": "96px",
      "position": "absolute",
      "margin": "auto",
      "top": "0",
      "left": "0",
      "right": "0",
      "bottom": "0"
    },
    attrs: {
      "src": _vm.photoSrc
    }
  }), _vm._v(" "), (_vm.editMode) ? _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/jpeg"
    },
    on: {
      "change": _vm.onPhotoInputChange
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.editMode) ? _c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.browseImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.BROWSE))]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.user.ThumbnailPhoto) ? _c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.REMOVE))]) : _vm._e()])])])], 1)])])]), _vm._v(" "), (!_vm.isNew) ? _c('div', {
    staticClass: "card card-default card-indent"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row py-1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('strong', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.USER_STATUS) + ": " + _vm._s(_vm.user.IsActive ? _vm.labels.ACTIVE : _vm.labels.INACTIVE))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isSabaUser && !_vm.user.IsActive) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activateUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.ACTIVATE))]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser && _vm.user.IsActive) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deactivateUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.DEACTIVATE))]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser && _vm.user.Locked) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unlockUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.UNLOCK))]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SET_PASSWORD))]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMID')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMID')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMID', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMID', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMPDigi')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMPDigi')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMPDigi', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMPDigi', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('Sharepoint')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('Sharepoint')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('Sharepoint', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('Sharepoint', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser && _vm.user.IsActive) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('None')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_GENERIC))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('None')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('MMID')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('MMID')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('MMPDigi')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_MMP))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('MMPDigi')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('Sharepoint')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('Sharepoint')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "height": "auto",
      "scrollable": true,
      "width": "650px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b75793c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditUser/EditUser.vue
// module id = 188
// module chunks = 1